import { EnrollmentType } from '../models/self-profile.model';

const ASYNC_MODALITY_CODE = 'ASYNC';

export function mapModalityCodeToEnrollmentType(code: string | null | undefined): EnrollmentType {
  return code === ASYNC_MODALITY_CODE ? 'ASYNCHRONOUS' : 'SYNCHRONOUS';
}
